import { createContext } from 'react';

export const RoContext = createContext({
  calculateBalance: () => {},
  handleSaveRoTableData: () => {},
  checkUpdate: () => {},
  rowData:''
});

export const CLRoContext = createContext({
  calculateBalance: () => {},
  handleSaveCLRoTableData: () => {},
  checkUpdate: () => {},
  rowData:''
});

export default  RoContext;